import { Title } from "./BoardInventoryStyles";
import { Formik } from "formik";
import { FormContainer } from "../parts/InventoryUpdates/InventoryUpdatesStyles";
import FormikSelect from "../../formik-form-components/FormikSelect";
import Button from "../../common/Button";
import { ButtonTypes } from "../../common/Button/constants";
import LoadingIcon from "../../common/LoadingIcon";
import * as Yup from "yup";
import { useAddBoardStencilAssociation } from "../../../utils/hooks/commonly-stored/uploaded-board/updates/board";
import { InventoryItemType } from "../../../utils/hooks/inventory/useInventoryItems";
import useAllInventoryItems from "../../../utils/hooks/inventory/useAllInventoryItems";

interface SelectStencilValues {
  stencils: string[];
}

const selectStencilsSchema = Yup.object().shape({
  stencils: Yup.array().of(Yup.string()),
});
export default function SelectStencil({
  boardId,
  closeModal,
}: {
  boardId: string;
  closeModal: () => void;
}) {
  const { items } = useAllInventoryItems(InventoryItemType.STENCIL);
  const { addStencilToBoard } = useAddBoardStencilAssociation();
  const selectStencilForProject = (values: SelectStencilValues) => {
    addStencilToBoard(boardId, {
      stencil_ids: values.stencils,
    });
    closeModal();
  };

  if (items === null) {
    return <LoadingIcon text={"Loading stencils..."} />;
  }
  return (
    <>
      <Title>Select stencil to associate with project</Title>
      <Formik
        initialValues={{
          stencils: [],
        }}
        onSubmit={selectStencilForProject}
        validationSchema={selectStencilsSchema}
      >
        {({ handleSubmit, isValid }) => (
          <FormContainer onSubmit={handleSubmit}>
            <FormikSelect
              name={"stencils"}
              label={"Stencils in inventory"}
              isMulti={true}
              options={items.inventory_items.map((stencil) => ({
                label: stencil.flashpcb_container_barcode,
                value: stencil.id,
              }))}
            />
            <Button
              label={"Update stencil association"}
              type={ButtonTypes.SUBMIT}
              centerText
              disabled={!isValid}
            />
          </FormContainer>
        )}
      </Formik>
    </>
  );
}
